import {
  LocationTypeSchema
} from "../chunk-HFBBEYPU.js";
import "../chunk-HJPR3SS7.js";
import {
  CreateDeliveryShipmentManifestSchema,
  CreateDeliveryShipmentPartitionAllocationSchema,
  CreateDeliveryShipmentPlanNodeSchema,
  DeliveryShipmentManifestDtoSchema,
  DeliveryShipmentManifestFlowSchema,
  DeliveryShipmentManifestReadinessDtoSchema,
  DeliveryShipmentManifestReadinessIssueSchema,
  DeliveryShipmentManifestReadinessSchema,
  DeliveryShipmentManifestSchema,
  DeliveryShipmentManifestStatusSchema,
  DeliveryShipmentPartitionAllocationDtoSchema,
  DeliveryShipmentPartitionAllocationSchema,
  DeliveryShipmentPartitionAllocationStateSchema,
  DeliveryShipmentPlanNodeDtoSchema,
  DeliveryShipmentPlanNodeSchema,
  DeliveryShipmentPlanNodeTypeSchema,
  HubLayoverScheduleSchema,
  HubNodeMetadataSchema,
  NodeAddressSnapshotSchema,
  ShipmentManifestDestinationSchema,
  ShipmentManifestPackageSchema,
  ShipmentManifestPayloadSnapshotSchema,
  ShipmentManifestShipperSchema,
  ShipmentManifestTransporterDetailSchema,
  ShipmentManifestTransporterSchema,
  UpdateDeliveryShipmentManifestSchema,
  UpdateDeliveryShipmentPartitionAllocationSchema,
  UpdateDeliveryShipmentPlanNodeSchema
} from "../chunk-3XEHZB66.js";

// delivery/webhook.types.ts
var OnfleetWebhookTriggers = {
  TASK_STARTED: 0,
  TASK_ETA: 1,
  TASK_ARRIVAL: 2,
  TASK_COMPLETED: 3,
  TASK_FAILED: 4,
  WORKER_DUTY: 5,
  TASK_CREATED: 6,
  TASK_UPDATED: 7,
  TASK_DELETED: 8,
  TASK_ASSIGNED: 9,
  TASK_UNASSIGNED: 10,
  TASK_CLONED: 11,
  TASK_DELAYED: 12,
  SMS_RECIPIENT_OPT_OUT: 13,
  SMS_RECIPIENT_RESPONSE: 14,
  WORKER_CREATED: 15,
  WORKER_DELETED: 16,
  WORKER_UPDATED: 25,
  AUTO_DISPATCH_JOB_COMPLETED: 24
};

// delivery/order-partition.schema.ts
import { z } from "zod";
var OrderPartitionFulfillmentTypeSchema = z.enum(["brand_driver", "flote_driver", "mail_carrier"]);
var OrderPartitionFulfillmentStatusSchema = z.enum([
  "pending_offer",
  "offer_sent",
  "accepted",
  "declined",
  "expired",
  "in_transit",
  "shipped",
  "assigned",
  "in_progress",
  "completed",
  "cancelled"
]);
var OrderPartitionPreparationStatusSchema = z.enum([
  "not_started",
  "packing",
  "ready_for_delivery",
  "out_for_delivery",
  "delivered",
  "finalized"
]);
var DbOrderPartitionSchema = z.object({
  id: z.string().uuid(),
  order_id: z.string().uuid().nullable(),
  b2bwave_order_id: z.string(),
  brand_id: z.string().uuid(),
  tracking_id: z.string(),
  portion_subtotal: z.string(),
  // DECIMAL stored as string
  portion_total: z.string(),
  fulfillment_type: OrderPartitionFulfillmentTypeSchema.nullable(),
  fulfillment_status: OrderPartitionFulfillmentStatusSchema,
  preparation_status: OrderPartitionPreparationStatusSchema,
  payment_method: z.string().nullable(),
  stock_location_id: z.string().uuid().nullable(),
  onfleet_task_id: z.string().nullable(),
  // Onfleet task reference
  shipping_carrier: z.string().nullable(),
  // Mail carrier: usps, ups, fedex
  carrier_tracking_number: z.string().nullable(),
  shipped_at: z.union([z.string(), z.date()]).nullable(),
  easypost_tracker_id: z.string().nullable(),
  // EasyPost tracker reference (trk_...)
  spread_rate: z.string().nullable(),
  spread_amount: z.string().nullable(),
  completed_at: z.union([z.string(), z.date()]).nullable(),
  // When marked as completed
  completed_by: z.string().nullable(),
  // Who/what completed it
  has_signature: z.boolean(),
  photo_count: z.number().int().nonnegative(),
  destination_organization_location_id: z.string().uuid().nullable(),
  metadata: z.record(z.unknown()),
  created_at: z.union([z.string(), z.date()]),
  updated_at: z.union([z.string(), z.date()])
});
var OrderPartitionSchema = z.object({
  id: z.string().uuid(),
  orderId: z.string().uuid().nullable(),
  b2bwaveOrderId: z.string(),
  brandId: z.string().uuid(),
  trackingId: z.string(),
  portionSubtotal: z.number(),
  portionTotal: z.number(),
  fulfillmentType: OrderPartitionFulfillmentTypeSchema.nullable(),
  fulfillmentStatus: OrderPartitionFulfillmentStatusSchema,
  preparationStatus: OrderPartitionPreparationStatusSchema,
  paymentMethod: z.string().nullable(),
  stockLocationId: z.string().uuid().nullable(),
  onfleetTaskId: z.string().nullable(),
  // Onfleet task reference
  shippingCarrier: z.string().nullable(),
  // Mail carrier: usps, ups, fedex
  carrierTrackingNumber: z.string().nullable(),
  shippedAt: z.date().nullable(),
  easypostTrackerId: z.string().nullable(),
  // EasyPost tracker reference (trk_...)
  spreadRate: z.number().nullable(),
  spreadAmount: z.number().nullable(),
  completedAt: z.date().nullable(),
  // When marked as completed
  completedBy: z.string().nullable(),
  // Who/what completed it
  hasSignature: z.boolean().optional(),
  photoCount: z.number().int().nonnegative().optional(),
  destinationOrganizationLocationId: z.string().uuid().nullable(),
  metadata: z.record(z.unknown()),
  createdAt: z.date(),
  updatedAt: z.date()
});
var OrderPartitionDtoSchema = z.object({
  id: z.string().uuid(),
  orderId: z.string().uuid().nullable(),
  b2bwaveOrderId: z.string(),
  brandId: z.string().uuid(),
  trackingId: z.string(),
  portionSubtotal: z.number(),
  portionTotal: z.number(),
  fulfillmentType: OrderPartitionFulfillmentTypeSchema.nullable(),
  fulfillmentStatus: OrderPartitionFulfillmentStatusSchema,
  preparationStatus: OrderPartitionPreparationStatusSchema,
  paymentMethod: z.string().nullable(),
  stockLocationId: z.string().uuid().nullable(),
  onfleetTaskId: z.string().nullable(),
  // Onfleet task reference
  shippingCarrier: z.string().nullable(),
  // Mail carrier: usps, ups, fedex
  carrierTrackingNumber: z.string().nullable(),
  shippedAt: z.string().datetime().nullable(),
  easypostTrackerId: z.string().nullable(),
  // EasyPost tracker reference (trk_...)
  spreadRate: z.number().nullable(),
  spreadAmount: z.number().nullable(),
  completedAt: z.string().datetime().nullable(),
  // When marked as completed
  completedBy: z.string().nullable(),
  // Who/what completed it
  hasSignature: z.boolean().optional(),
  photoCount: z.number().int().nonnegative().optional(),
  destinationOrganizationLocationId: z.string().uuid().nullable().optional(),
  metadata: z.record(z.unknown()),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  customerName: z.string().nullish(),
  // Enriched field: contact name from shipping address
  companyName: z.string().nullish(),
  // Enriched field: company name from customer record
  customerLicenseNumber: z.string().nullish(),
  // Enriched field: active license number from compliance.licenses
  totalQuantity: z.number().int().nonnegative().optional(),
  // Sum of all line item quantities
  itemCount: z.number().int().nonnegative().optional()
  // Count of distinct line items (unique SKUs)
});
var CreateOrderPartitionDtoSchema = z.object({
  orderId: z.string().uuid().optional(),
  b2bwaveOrderId: z.string(),
  brandId: z.string().uuid(),
  trackingId: z.string(),
  portionSubtotal: z.number(),
  portionTotal: z.number(),
  paymentMethod: z.string().optional(),
  stockLocationId: z.string().uuid().optional(),
  metadata: z.record(z.unknown()).optional()
});
var UpdateOrderPartitionDtoSchema = z.object({
  fulfillmentType: OrderPartitionFulfillmentTypeSchema.optional(),
  fulfillmentStatus: OrderPartitionFulfillmentStatusSchema.optional(),
  preparationStatus: OrderPartitionPreparationStatusSchema.optional(),
  stockLocationId: z.string().uuid().nullable().optional(),
  onfleetTaskId: z.string().nullable().optional(),
  // Onfleet task reference
  shippingCarrier: z.string().nullable().optional(),
  // Mail carrier: usps, ups, fedex
  carrierTrackingNumber: z.string().nullable().optional(),
  shippedAt: z.date().nullable().optional(),
  easypostTrackerId: z.string().nullable().optional(),
  // EasyPost tracker reference (trk_...)
  spreadRate: z.number().nullable().optional(),
  spreadAmount: z.number().nullable().optional(),
  completedAt: z.date().nullable().optional(),
  // When fulfillment was completed
  completedBy: z.string().nullable().optional(),
  // Who completed: 'onfleet_webhook', 'manual:{userId}', 'reconciliation_job'
  hasSignature: z.boolean().optional(),
  photoCount: z.number().int().nonnegative().optional(),
  destinationOrganizationLocationId: z.string().uuid().nullable().optional(),
  metadata: z.record(z.unknown()).optional()
});
var OrderPartitionFiltersSchema = z.object({
  orderId: z.string().uuid().optional(),
  b2bwaveOrderId: z.string().optional(),
  brandId: z.string().uuid().optional(),
  brandIds: z.array(z.string().uuid()).optional(),
  fulfillmentStatus: OrderPartitionFulfillmentStatusSchema.optional(),
  preparationStatus: OrderPartitionPreparationStatusSchema.optional(),
  fulfillmentType: OrderPartitionFulfillmentTypeSchema.optional(),
  paymentMethod: z.string().optional(),
  fromDate: z.string().datetime().optional(),
  toDate: z.string().datetime().optional(),
  limit: z.number().int().positive().optional(),
  cursor: z.string().optional(),
  productSku: z.string().optional(),
  search: z.string().optional(),
  stockLocationId: z.string().uuid().optional(),
  // Special filter: flote_driver OR NULL (for delivery-admin)
  floteManaged: z.boolean().optional()
});
var PaginatedOrderPartitionsSchema = z.object({
  items: z.array(OrderPartitionDtoSchema),
  nextCursor: z.string().optional(),
  totalCount: z.number().int().optional()
});
var StalePartitionFiltersSchema = z.object({
  /** Fulfillment statuses to check (partitions in these statuses that should be completed) */
  statuses: z.array(OrderPartitionFulfillmentStatusSchema),
  /** Partitions older than this date are considered stale */
  olderThan: z.date().optional(),
  /** Only include partitions shipped before this date */
  shippedBefore: z.date().optional(),
  /** Only include partitions with an Onfleet task assigned */
  hasOnfleetTaskId: z.boolean().optional(),
  /** Only include partitions with an EasyPost tracker */
  hasEasypostTracker: z.boolean().optional()
});

// delivery/fulfillment-offer.schema.ts
import { z as z2 } from "zod";
var FulfillmentOfferStatusSchema = z2.enum([
  "pending",
  "accepted",
  "declined",
  "expired",
  "cancelled"
]);
var DbFulfillmentOfferSchema = z2.object({
  id: z2.string().uuid(),
  order_partition_id: z2.string().uuid(),
  status: FulfillmentOfferStatusSchema,
  expires_at: z2.union([z2.string(), z2.date()]),
  responded_at: z2.union([z2.string(), z2.date()]).nullable(),
  responded_by_portal_user_id: z2.string().uuid().nullable(),
  response_reason: z2.string().nullable(),
  created_at: z2.union([z2.string(), z2.date()])
});
var FulfillmentOfferSchema = z2.object({
  id: z2.string().uuid(),
  orderPartitionId: z2.string().uuid(),
  status: FulfillmentOfferStatusSchema,
  expiresAt: z2.date(),
  respondedAt: z2.date().nullable(),
  respondedByPortalUserId: z2.string().uuid().nullable(),
  responseReason: z2.string().nullable(),
  createdAt: z2.date()
});
var FulfillmentOfferDtoSchema = z2.object({
  id: z2.string().uuid(),
  orderPartitionId: z2.string().uuid(),
  status: FulfillmentOfferStatusSchema,
  expiresAt: z2.string().datetime(),
  respondedAt: z2.string().datetime().nullable(),
  respondedByPortalUserId: z2.string().uuid().nullable(),
  responseReason: z2.string().nullable(),
  createdAt: z2.string().datetime()
});
var CreateFulfillmentOfferDtoSchema = z2.object({
  orderPartitionId: z2.string().uuid(),
  expiresAt: z2.string().datetime()
});
var RespondToOfferDtoSchema = z2.object({
  accept: z2.boolean(),
  reason: z2.string().optional()
});
var FulfillmentOfferFiltersSchema = z2.object({
  orderPartitionId: z2.string().uuid().optional(),
  status: FulfillmentOfferStatusSchema.optional(),
  expiresBefore: z2.string().datetime().optional(),
  expiresAfter: z2.string().datetime().optional(),
  limit: z2.number().int().positive().optional(),
  cursor: z2.string().optional()
});
var PaginatedFulfillmentOffersSchema = z2.object({
  items: z2.array(FulfillmentOfferDtoSchema),
  nextCursor: z2.string().optional(),
  totalCount: z2.number().int().optional()
});
var FulfillmentOfferWithPartitionDtoSchema = FulfillmentOfferDtoSchema.extend({
  partition: z2.object({
    id: z2.string().uuid(),
    b2bwaveOrderId: z2.string(),
    brandId: z2.string().uuid(),
    trackingId: z2.string(),
    portionSubtotal: z2.number(),
    portionTotal: z2.number(),
    paymentMethod: z2.string().nullable()
  })
});
var OfferResponseDtoSchema = z2.object({
  offer: FulfillmentOfferDtoSchema,
  partition: OrderPartitionDtoSchema
});
var ExpireOffersResponseDtoSchema = z2.object({
  expiredCount: z2.number().int().nonnegative()
});
var PartitionItemDtoSchema = z2.object({
  id: z2.string().uuid(),
  orderPartitionId: z2.string().uuid(),
  productVariantId: z2.string().uuid(),
  productId: z2.string().uuid().optional(),
  quantity: z2.number().int().nonnegative(),
  reservedQuantity: z2.number().int().nonnegative(),
  fulfilledQuantity: z2.number().int().nonnegative(),
  unitPrice: z2.string(),
  lineTotal: z2.string(),
  productName: z2.string().optional(),
  productCode: z2.string().optional()
});
var FulfillmentOfferWithPartitionAndItemsDtoSchema = FulfillmentOfferDtoSchema.extend({
  partition: z2.object({
    id: z2.string().uuid(),
    b2bwaveOrderId: z2.string(),
    brandId: z2.string().uuid(),
    trackingId: z2.string(),
    portionSubtotal: z2.number(),
    portionTotal: z2.number(),
    paymentMethod: z2.string().nullable()
  }),
  items: z2.array(PartitionItemDtoSchema)
});

// delivery/order-partition-item.schema.ts
import { z as z3 } from "zod";
var DbOrderPartitionItemSchema = z3.object({
  id: z3.string().uuid(),
  order_partition_id: z3.string().uuid(),
  product_variant_id: z3.string().uuid(),
  inventory_item_id: z3.string().uuid().nullable(),
  b2bwave_line_item_id: z3.string().nullable(),
  quantity: z3.number().int().nonnegative(),
  reserved_quantity: z3.number().int().nonnegative(),
  fulfilled_quantity: z3.number().int().nonnegative(),
  unit_price: z3.string(),
  // DECIMAL stored as string
  line_total: z3.string(),
  fulfilled_at: z3.union([z3.string(), z3.date()]).nullable(),
  // When this item was fulfilled
  reserved_at: z3.union([z3.string(), z3.date()]).nullable(),
  // When inventory was reserved
  stock_deducted_at: z3.union([z3.string(), z3.date()]).nullable(),
  // When physical stock was deducted
  metadata: z3.record(z3.unknown()),
  created_at: z3.union([z3.string(), z3.date()]),
  updated_at: z3.union([z3.string(), z3.date()])
});
var OrderPartitionItemSchema = z3.object({
  id: z3.string().uuid(),
  orderPartitionId: z3.string().uuid(),
  productVariantId: z3.string().uuid(),
  inventoryItemId: z3.string().uuid().nullable(),
  quantity: z3.number().int().nonnegative(),
  reservedQuantity: z3.number().int().nonnegative(),
  fulfilledQuantity: z3.number().int().nonnegative(),
  unitPrice: z3.string(),
  // DECIMAL stored as string
  lineTotal: z3.string(),
  fulfilledAt: z3.date().nullable(),
  // When this item was fulfilled
  reservedAt: z3.date().nullable(),
  // When inventory was reserved
  stockDeductedAt: z3.date().nullable(),
  // When physical stock was deducted (idempotency guard)
  metadata: z3.record(z3.unknown()),
  createdAt: z3.date(),
  updatedAt: z3.date()
});
var CreateOrderPartitionItemDtoSchema = z3.object({
  orderPartitionId: z3.string().uuid(),
  productVariantId: z3.string().uuid(),
  b2bwaveLineItemId: z3.string().optional(),
  quantity: z3.number().int().nonnegative(),
  unitPrice: z3.string(),
  // DECIMAL stored as string
  lineTotal: z3.string(),
  metadata: z3.record(z3.unknown()).optional()
});
var OrderPartitionItemWithProductSchema = OrderPartitionItemSchema.extend({
  productId: z3.string().uuid().optional(),
  productName: z3.string().optional(),
  productCode: z3.string().optional(),
  productThumbnail: z3.string().url().optional()
});

// delivery/order-partition-item-batch-reservation.schema.ts
import { z as z4 } from "zod";
var DbOrderPartitionItemBatchReservationSchema = z4.object({
  id: z4.string().uuid(),
  order_partition_item_id: z4.string().uuid(),
  inventory_batch_id: z4.string().uuid(),
  inventory_item_id: z4.string().uuid(),
  stock_location_id: z4.string().uuid(),
  reserved_quantity: z4.number().int().positive(),
  released_quantity: z4.number().int().nonnegative(),
  consumed_quantity: z4.number().int().nonnegative(),
  metrc_package_tag_snapshot: z4.string().nullable(),
  batch_number_snapshot: z4.string().nullable(),
  lot_number_snapshot: z4.string().nullable(),
  received_date_snapshot: z4.union([z4.string(), z4.date()]),
  expiry_date_snapshot: z4.union([z4.string(), z4.date()]).nullable(),
  reserved_at: z4.union([z4.string(), z4.date()]),
  released_at: z4.union([z4.string(), z4.date()]).nullable(),
  consumed_at: z4.union([z4.string(), z4.date()]).nullable(),
  metadata: z4.record(z4.unknown()),
  created_at: z4.union([z4.string(), z4.date()]),
  updated_at: z4.union([z4.string(), z4.date()])
});
var OrderPartitionItemBatchReservationSchema = z4.object({
  id: z4.string().uuid(),
  orderPartitionItemId: z4.string().uuid(),
  inventoryBatchId: z4.string().uuid(),
  inventoryItemId: z4.string().uuid(),
  stockLocationId: z4.string().uuid(),
  reservedQuantity: z4.number().int().positive(),
  releasedQuantity: z4.number().int().nonnegative(),
  consumedQuantity: z4.number().int().nonnegative(),
  remainingQuantity: z4.number().int().nonnegative(),
  metrcPackageTagSnapshot: z4.string().nullable(),
  batchNumberSnapshot: z4.string().nullable(),
  lotNumberSnapshot: z4.string().nullable(),
  receivedDateSnapshot: z4.date(),
  expiryDateSnapshot: z4.date().nullable(),
  reservedAt: z4.date(),
  releasedAt: z4.date().nullable(),
  consumedAt: z4.date().nullable(),
  metadata: z4.record(z4.unknown()),
  createdAt: z4.date(),
  updatedAt: z4.date()
});
var CreateOrderPartitionItemBatchReservationDtoSchema = z4.object({
  orderPartitionItemId: z4.string().uuid(),
  inventoryBatchId: z4.string().uuid(),
  inventoryItemId: z4.string().uuid(),
  stockLocationId: z4.string().uuid(),
  reservedQuantity: z4.number().int().positive(),
  metrcPackageTagSnapshot: z4.string().nullable().optional(),
  batchNumberSnapshot: z4.string().nullable().optional(),
  lotNumberSnapshot: z4.string().nullable().optional(),
  receivedDateSnapshot: z4.date(),
  expiryDateSnapshot: z4.date().nullable().optional(),
  reservedAt: z4.date().optional(),
  metadata: z4.record(z4.unknown()).optional()
});

// delivery/fulfillment-record.schema.ts
import { z as z5 } from "zod";
var FulfillmentRecordFulfillmentTypeSchema = z5.enum(["brand_driver", "flote_driver", "mail_carrier"]);
var DbFulfillmentRecordSchema = z5.object({
  id: z5.string().uuid(),
  order_partition_id: z5.string().uuid(),
  order_partition_item_id: z5.string().uuid(),
  inventory_item_id: z5.string().uuid().nullable(),
  brand_id: z5.string().uuid(),
  stock_location_id: z5.string().uuid().nullable(),
  b2bwave_order_id: z5.string().nullable(),
  quantity: z5.number().int().positive(),
  unit_price: z5.string(),
  // DECIMAL stored as string
  line_total: z5.string(),
  fulfillment_type: FulfillmentRecordFulfillmentTypeSchema.nullable(),
  delivery_spread_rate: z5.string().nullable(),
  delivery_spread_amount: z5.string().nullable(),
  fulfilled_at: z5.union([z5.string(), z5.date()]),
  fulfilled_by: z5.string(),
  metadata: z5.record(z5.unknown()),
  created_at: z5.union([z5.string(), z5.date()])
});
var FulfillmentRecordSchema = z5.object({
  id: z5.string().uuid(),
  orderPartitionId: z5.string().uuid(),
  orderPartitionItemId: z5.string().uuid(),
  inventoryItemId: z5.string().uuid().nullable(),
  brandId: z5.string().uuid(),
  stockLocationId: z5.string().uuid().nullable(),
  b2bwaveOrderId: z5.string().nullable(),
  quantity: z5.number().int().positive(),
  unitPrice: z5.number(),
  lineTotal: z5.number(),
  fulfillmentType: FulfillmentRecordFulfillmentTypeSchema.nullable(),
  deliverySpreadRate: z5.number().nullable(),
  deliverySpreadAmount: z5.number().nullable(),
  fulfilledAt: z5.date(),
  fulfilledBy: z5.string(),
  metadata: z5.record(z5.unknown()),
  createdAt: z5.date()
});
var FulfillmentRecordDtoSchema = z5.object({
  id: z5.string().uuid(),
  orderPartitionId: z5.string().uuid(),
  orderPartitionItemId: z5.string().uuid(),
  inventoryItemId: z5.string().uuid().nullable(),
  brandId: z5.string().uuid(),
  stockLocationId: z5.string().uuid().nullable(),
  b2bwaveOrderId: z5.string().nullable(),
  quantity: z5.number().int().positive(),
  unitPrice: z5.number(),
  lineTotal: z5.number(),
  fulfillmentType: FulfillmentRecordFulfillmentTypeSchema.nullable(),
  deliverySpreadRate: z5.number().nullable(),
  deliverySpreadAmount: z5.number().nullable(),
  fulfilledAt: z5.string().datetime(),
  fulfilledBy: z5.string(),
  metadata: z5.record(z5.unknown()),
  createdAt: z5.string().datetime()
});
var CreateFulfillmentRecordDtoSchema = z5.object({
  orderPartitionId: z5.string().uuid(),
  orderPartitionItemId: z5.string().uuid(),
  inventoryItemId: z5.string().uuid().nullable().optional(),
  brandId: z5.string().uuid(),
  stockLocationId: z5.string().uuid().nullable().optional(),
  b2bwaveOrderId: z5.string().nullable().optional(),
  quantity: z5.number().int().positive(),
  unitPrice: z5.number(),
  lineTotal: z5.number(),
  fulfillmentType: FulfillmentRecordFulfillmentTypeSchema.nullable().optional(),
  deliverySpreadRate: z5.number().nullable().optional(),
  deliverySpreadAmount: z5.number().nullable().optional(),
  fulfilledBy: z5.string(),
  metadata: z5.record(z5.unknown()).optional()
});
var FulfillmentRecordFiltersSchema = z5.object({
  orderPartitionId: z5.string().uuid().optional(),
  brandId: z5.string().uuid().optional(),
  stockLocationId: z5.string().uuid().optional(),
  fulfillmentType: FulfillmentRecordFulfillmentTypeSchema.optional(),
  fromDate: z5.string().datetime().optional(),
  toDate: z5.string().datetime().optional(),
  limit: z5.number().int().positive().optional(),
  cursor: z5.string().optional()
});
var BrandFulfillmentSummarySchema = z5.object({
  brandId: z5.string().uuid(),
  brandName: z5.string().optional(),
  date: z5.string(),
  // ISO date string (YYYY-MM-DD)
  ordersFulfilled: z5.number().int().nonnegative(),
  unitsSold: z5.number().int().nonnegative(),
  grossRevenue: z5.number(),
  deliveryFees: z5.number(),
  netRevenue: z5.number()
});
var StockLocationPerformanceSchema = z5.object({
  stockLocationId: z5.string().uuid(),
  locationName: z5.string().optional(),
  itemsFulfilled: z5.number().int().nonnegative(),
  unitsFulfilled: z5.number().int().nonnegative(),
  avgFulfillmentHours: z5.number().nullable()
});
var FulfillmentResultSchema = z5.object({
  success: z5.boolean(),
  alreadyCompleted: z5.boolean().optional(),
  itemsProcessed: z5.number().int().nonnegative().optional(),
  errors: z5.array(z5.object({
    itemId: z5.string().uuid(),
    error: z5.string()
  })).optional()
});

// delivery/assignment-queue.schema.ts
import { z as z6 } from "zod";
var AssignmentQueueStatusSchema = z6.enum([
  "pending",
  // Awaiting assignment
  "processing",
  // Assignment in progress (optimistic lock)
  "assigned",
  // Driver assigned successfully
  "expired",
  // Offer/assignment window expired
  "cancelled"
  // Manually removed from queue
]);
var DbAssignmentQueueSchema = z6.object({
  id: z6.string().uuid(),
  partition_id: z6.string().uuid(),
  organization_id: z6.string().uuid().nullable(),
  supplier_id: z6.string().uuid().nullable(),
  stock_location_id: z6.string().uuid(),
  priority: z6.number().int(),
  enqueued_at: z6.union([z6.string(), z6.date()]),
  expires_at: z6.union([z6.string(), z6.date()]).nullable(),
  order_value: z6.string().nullable(),
  // DECIMAL stored as string
  status: AssignmentQueueStatusSchema,
  assigned_at: z6.union([z6.string(), z6.date()]).nullable(),
  assigned_driver_id: z6.string().uuid().nullable(),
  metadata: z6.record(z6.unknown()),
  created_at: z6.union([z6.string(), z6.date()]),
  updated_at: z6.union([z6.string(), z6.date()])
});
var AssignmentQueueEntrySchema = z6.object({
  id: z6.string().uuid(),
  partitionId: z6.string().uuid(),
  organizationId: z6.string().uuid().nullable(),
  supplierId: z6.string().uuid().nullable(),
  stockLocationId: z6.string().uuid(),
  priority: z6.number().int(),
  enqueuedAt: z6.date(),
  expiresAt: z6.date().nullable(),
  orderValue: z6.number().nullable(),
  status: AssignmentQueueStatusSchema,
  assignedAt: z6.date().nullable(),
  assignedDriverId: z6.string().uuid().nullable(),
  metadata: z6.record(z6.unknown()),
  createdAt: z6.date(),
  updatedAt: z6.date()
});
var AssignmentQueueEntryDtoSchema = z6.object({
  id: z6.string().uuid(),
  partitionId: z6.string().uuid(),
  organizationId: z6.string().uuid().nullable(),
  supplierId: z6.string().uuid().nullable(),
  stockLocationId: z6.string().uuid(),
  priority: z6.number().int(),
  enqueuedAt: z6.string().datetime(),
  expiresAt: z6.string().datetime().nullable(),
  orderValue: z6.number().nullable(),
  status: AssignmentQueueStatusSchema,
  assignedAt: z6.string().datetime().nullable(),
  assignedDriverId: z6.string().uuid().nullable(),
  metadata: z6.record(z6.unknown()),
  createdAt: z6.string().datetime(),
  updatedAt: z6.string().datetime(),
  // Enriched fields for display
  trackingId: z6.string().optional(),
  customerName: z6.string().optional(),
  portionTotal: z6.number().optional()
});
var CreateAssignmentQueueEntrySchema = z6.object({
  partitionId: z6.string().uuid(),
  organizationId: z6.string().uuid().nullable().optional(),
  supplierId: z6.string().uuid().nullable().optional(),
  stockLocationId: z6.string().uuid(),
  priority: z6.number().int().optional(),
  // Calculated if not provided
  expiresAt: z6.date().optional(),
  orderValue: z6.number().optional(),
  metadata: z6.record(z6.unknown()).optional()
});
var UpdateAssignmentQueueEntrySchema = z6.object({
  priority: z6.number().int().optional(),
  status: AssignmentQueueStatusSchema.optional(),
  assignedAt: z6.date().nullable().optional(),
  assignedDriverId: z6.string().uuid().nullable().optional(),
  metadata: z6.record(z6.unknown()).optional()
});
var AssignmentQueueFiltersSchema = z6.object({
  organizationId: z6.string().uuid().optional(),
  supplierId: z6.string().uuid().optional(),
  stockLocationId: z6.string().uuid().optional(),
  status: AssignmentQueueStatusSchema.optional(),
  statuses: z6.array(AssignmentQueueStatusSchema).optional(),
  expiringBefore: z6.date().optional(),
  limit: z6.number().int().positive().optional()
});
var AssignmentQueueStatsSchema = z6.object({
  pending: z6.number().int(),
  processing: z6.number().int(),
  assigned: z6.number().int(),
  expired: z6.number().int(),
  avgWaitTimeMs: z6.number().nullable(),
  // Average time from enqueue to assignment
  expiringWithin30Min: z6.number().int()
});

// delivery/shipment-leg.schema.ts
import { z as z7 } from "zod";
var DeliveryShipmentStatusSchema = z7.enum([
  "planned",
  "dispatched",
  "in_transit",
  "at_layover",
  "split",
  "completed",
  "cancelled"
]);
var DeliveryShipmentLegTypeSchema = z7.enum([
  "pickup",
  "linehaul",
  "layover_handoff",
  "final_mile",
  "staging_dropoff"
]);
var DeliveryShipmentLegStatusSchema = z7.enum([
  "planned",
  "queued",
  "assigned",
  "in_progress",
  "completed",
  "failed",
  "cancelled"
]);
var DeliveryShipmentLegAllocationStateSchema = z7.enum([
  "planned",
  "active",
  "transferred",
  "terminal_completed",
  "removed"
]);
var DeliveryShipmentLegQueueStatusSchema = z7.enum([
  "pending",
  "processing",
  "assigned",
  "expired",
  "cancelled"
]);
var DownstreamDraftPublishStatusSchema = z7.enum([
  "draft",
  "confirmed",
  "published",
  "publish_failed"
]);
var DeliveryShipmentSchema = z7.object({
  id: z7.string().uuid(),
  organizationId: z7.string().uuid(),
  sourceStockLocationId: z7.string().uuid(),
  status: DeliveryShipmentStatusSchema,
  metadata: z7.record(z7.unknown()),
  createdAt: z7.date(),
  updatedAt: z7.date()
});
var DeliveryShipmentLegSchema = z7.object({
  id: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  sequence: z7.number().int().positive(),
  legType: DeliveryShipmentLegTypeSchema,
  originLocationId: z7.string().uuid().nullable(),
  destinationLocationId: z7.string().uuid().nullable(),
  organizationId: z7.string().uuid(),
  status: DeliveryShipmentLegStatusSchema,
  assignedDriverId: z7.string().uuid().nullable(),
  onfleetTaskId: z7.string().nullable(),
  onfleetPickupTaskId: z7.string().nullable(),
  onfleetOrderId: z7.string().nullable(),
  onfleetRoutePlanId: z7.string().nullable(),
  fromNodeId: z7.string().uuid().nullable(),
  toNodeId: z7.string().uuid().nullable(),
  startedAt: z7.date().nullable(),
  completedAt: z7.date().nullable(),
  metadata: z7.record(z7.unknown()),
  createdAt: z7.date(),
  updatedAt: z7.date()
});
var DeliveryShipmentLegAllocationSchema = z7.object({
  id: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  partitionId: z7.string().uuid(),
  allocationState: DeliveryShipmentLegAllocationStateSchema,
  isTerminalDestinationForPartition: z7.boolean(),
  finalRecipientLocationId: z7.string().uuid().nullable(),
  destinationComplianceLicenseId: z7.string().uuid().nullable(),
  metadata: z7.record(z7.unknown()),
  createdAt: z7.date(),
  updatedAt: z7.date()
});
var DeliveryShipmentLegMetrcRefSchema = z7.object({
  id: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  partitionId: z7.string().uuid().nullable(),
  metrcDeliveryId: z7.string().nullable(),
  metrcTransferId: z7.string().nullable(),
  metrcManifestNumber: z7.string().nullable(),
  isLayover: z7.boolean().nullable(),
  metrcTransporterFacilityLicenseNumber: z7.string().nullable(),
  metrcTransporterAcceptedAt: z7.date().nullable(),
  metrcEstimatedDepartureAt: z7.date().nullable(),
  metrcActualDepartureAt: z7.date().nullable(),
  metrcEstimatedArrivalAt: z7.date().nullable(),
  metrcActualArrivalAt: z7.date().nullable(),
  metadata: z7.record(z7.unknown()),
  createdAt: z7.date(),
  updatedAt: z7.date()
});
var DeliveryShipmentLegQueueEntrySchema = z7.object({
  id: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  organizationId: z7.string().uuid(),
  stockLocationId: z7.string().uuid(),
  priority: z7.number().int(),
  status: DeliveryShipmentLegQueueStatusSchema,
  assignedDriverId: z7.string().uuid().nullable(),
  expiresAt: z7.date().nullable(),
  enqueuedAt: z7.date(),
  assignedAt: z7.date().nullable(),
  metadata: z7.record(z7.unknown()),
  createdAt: z7.date(),
  updatedAt: z7.date()
});
var DeliveryShipmentLegQueueListItemSchema = DeliveryShipmentLegQueueEntrySchema.extend({
  shipmentId: z7.string().uuid(),
  legType: DeliveryShipmentLegTypeSchema,
  legStatus: DeliveryShipmentLegStatusSchema,
  originLocationId: z7.string().uuid().nullable(),
  originLocationName: z7.string().nullable(),
  destinationLocationId: z7.string().uuid().nullable(),
  destinationLocationName: z7.string().nullable(),
  partitionCount: z7.number().int().nonnegative(),
  partitionIds: z7.array(z7.string().uuid()),
  metrcManifestCount: z7.number().int().nonnegative()
});
var DeliveryDownstreamTaskDraftSchema = z7.object({
  id: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  partitionIds: z7.array(z7.string().uuid()),
  status: DownstreamDraftPublishStatusSchema,
  onfleetTaskId: z7.string().nullable(),
  failureReason: z7.string().nullable().optional(),
  metadata: z7.record(z7.unknown()).default({}),
  createdAt: z7.date(),
  updatedAt: z7.date()
});
var CreateDeliveryShipmentSchema = z7.object({
  organizationId: z7.string().uuid(),
  sourceStockLocationId: z7.string().uuid(),
  status: DeliveryShipmentStatusSchema.optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var UpdateDeliveryShipmentSchema = z7.object({
  sourceStockLocationId: z7.string().uuid().optional(),
  status: DeliveryShipmentStatusSchema.optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentFiltersSchema = z7.object({
  status: DeliveryShipmentStatusSchema.optional(),
  statuses: z7.array(DeliveryShipmentStatusSchema).optional(),
  sourceStockLocationId: z7.string().uuid().optional(),
  limit: z7.number().int().positive().optional()
});
var CreateDeliveryShipmentLegSchema = z7.object({
  shipmentId: z7.string().uuid(),
  sequence: z7.number().int().positive(),
  legType: DeliveryShipmentLegTypeSchema,
  originLocationId: z7.string().uuid().nullable().optional(),
  destinationLocationId: z7.string().uuid().nullable().optional(),
  organizationId: z7.string().uuid(),
  status: DeliveryShipmentLegStatusSchema.optional(),
  assignedDriverId: z7.string().uuid().nullable().optional(),
  onfleetTaskId: z7.string().nullable().optional(),
  onfleetPickupTaskId: z7.string().nullable().optional(),
  onfleetOrderId: z7.string().nullable().optional(),
  onfleetRoutePlanId: z7.string().nullable().optional(),
  fromNodeId: z7.string().uuid().nullable().optional(),
  toNodeId: z7.string().uuid().nullable().optional(),
  startedAt: z7.date().nullable().optional(),
  completedAt: z7.date().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var UpdateDeliveryShipmentLegSchema = z7.object({
  sequence: z7.number().int().positive().optional(),
  legType: DeliveryShipmentLegTypeSchema.optional(),
  originLocationId: z7.string().uuid().nullable().optional(),
  destinationLocationId: z7.string().uuid().nullable().optional(),
  status: DeliveryShipmentLegStatusSchema.optional(),
  assignedDriverId: z7.string().uuid().nullable().optional(),
  onfleetTaskId: z7.string().nullable().optional(),
  onfleetPickupTaskId: z7.string().nullable().optional(),
  onfleetOrderId: z7.string().nullable().optional(),
  onfleetRoutePlanId: z7.string().nullable().optional(),
  fromNodeId: z7.string().uuid().nullable().optional(),
  toNodeId: z7.string().uuid().nullable().optional(),
  startedAt: z7.date().nullable().optional(),
  completedAt: z7.date().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentLegFiltersSchema = z7.object({
  status: DeliveryShipmentLegStatusSchema.optional(),
  statuses: z7.array(DeliveryShipmentLegStatusSchema).optional(),
  legType: DeliveryShipmentLegTypeSchema.optional(),
  legTypes: z7.array(DeliveryShipmentLegTypeSchema).optional(),
  organizationId: z7.string().uuid().optional(),
  assignedDriverId: z7.string().uuid().optional(),
  limit: z7.number().int().positive().optional()
});
var CreateDeliveryShipmentLegAllocationSchema = z7.object({
  shipmentLegId: z7.string().uuid(),
  partitionId: z7.string().uuid(),
  allocationState: DeliveryShipmentLegAllocationStateSchema.optional(),
  isTerminalDestinationForPartition: z7.boolean().optional(),
  finalRecipientLocationId: z7.string().uuid().nullable().optional(),
  destinationComplianceLicenseId: z7.string().uuid().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var UpdateDeliveryShipmentLegAllocationSchema = z7.object({
  allocationState: DeliveryShipmentLegAllocationStateSchema.optional(),
  isTerminalDestinationForPartition: z7.boolean().optional(),
  finalRecipientLocationId: z7.string().uuid().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentLegAllocationFiltersSchema = z7.object({
  allocationState: DeliveryShipmentLegAllocationStateSchema.optional(),
  allocationStates: z7.array(DeliveryShipmentLegAllocationStateSchema).optional(),
  shipmentLegId: z7.string().uuid().optional(),
  partitionId: z7.string().uuid().optional(),
  limit: z7.number().int().positive().optional()
});
var CreateDeliveryShipmentLegMetrcRefSchema = z7.object({
  shipmentLegId: z7.string().uuid(),
  partitionId: z7.string().uuid().nullable().optional(),
  metrcDeliveryId: z7.string().nullable().optional(),
  metrcTransferId: z7.string().nullable().optional(),
  metrcManifestNumber: z7.string().nullable().optional(),
  isLayover: z7.boolean().nullable().optional(),
  metrcTransporterFacilityLicenseNumber: z7.string().nullable().optional(),
  metrcTransporterAcceptedAt: z7.date().nullable().optional(),
  metrcEstimatedDepartureAt: z7.date().nullable().optional(),
  metrcActualDepartureAt: z7.date().nullable().optional(),
  metrcEstimatedArrivalAt: z7.date().nullable().optional(),
  metrcActualArrivalAt: z7.date().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var UpdateDeliveryShipmentLegMetrcRefSchema = z7.object({
  metrcDeliveryId: z7.string().nullable().optional(),
  metrcTransferId: z7.string().nullable().optional(),
  metrcManifestNumber: z7.string().nullable().optional(),
  isLayover: z7.boolean().nullable().optional(),
  metrcTransporterFacilityLicenseNumber: z7.string().nullable().optional(),
  metrcTransporterAcceptedAt: z7.date().nullable().optional(),
  metrcEstimatedDepartureAt: z7.date().nullable().optional(),
  metrcActualDepartureAt: z7.date().nullable().optional(),
  metrcEstimatedArrivalAt: z7.date().nullable().optional(),
  metrcActualArrivalAt: z7.date().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentLegMetrcRefFiltersSchema = z7.object({
  partitionId: z7.string().uuid().optional(),
  metrcDeliveryId: z7.string().optional(),
  metrcTransferId: z7.string().optional(),
  metrcManifestNumber: z7.string().optional(),
  isLayover: z7.boolean().optional(),
  limit: z7.number().int().positive().optional()
});
var CreateDeliveryShipmentLegQueueEntrySchema = z7.object({
  shipmentLegId: z7.string().uuid(),
  organizationId: z7.string().uuid(),
  stockLocationId: z7.string().uuid(),
  priority: z7.number().int().optional(),
  status: DeliveryShipmentLegQueueStatusSchema.optional(),
  assignedDriverId: z7.string().uuid().nullable().optional(),
  expiresAt: z7.date().nullable().optional(),
  enqueuedAt: z7.date().optional(),
  assignedAt: z7.date().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var UpdateDeliveryShipmentLegQueueEntrySchema = z7.object({
  priority: z7.number().int().optional(),
  status: DeliveryShipmentLegQueueStatusSchema.optional(),
  assignedDriverId: z7.string().uuid().nullable().optional(),
  expiresAt: z7.date().nullable().optional(),
  assignedAt: z7.date().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentLegQueueFiltersSchema = z7.object({
  status: DeliveryShipmentLegQueueStatusSchema.optional(),
  statuses: z7.array(DeliveryShipmentLegQueueStatusSchema).optional(),
  stockLocationId: z7.string().uuid().optional(),
  limit: z7.number().int().positive().optional(),
  offset: z7.number().int().nonnegative().optional()
});
var DeliveryShipmentLegQueueStatsSchema = z7.object({
  pending: z7.number().int().nonnegative(),
  processing: z7.number().int().nonnegative(),
  assigned: z7.number().int().nonnegative(),
  expired: z7.number().int().nonnegative(),
  cancelled: z7.number().int().nonnegative(),
  avgWaitTimeMs: z7.number().nullable(),
  expiringWithin30Min: z7.number().int().nonnegative()
});
var DeliveryShipmentLegQueueSummarySchema = z7.object({
  shipmentId: z7.string().uuid(),
  shipmentStatus: DeliveryShipmentStatusSchema,
  originLocationId: z7.string().uuid().nullable(),
  originLocationName: z7.string().nullable(),
  destinationLocationId: z7.string().uuid().nullable(),
  destinationLocationName: z7.string().nullable(),
  legCount: z7.number().int().nonnegative(),
  partitionCount: z7.number().int().nonnegative(),
  pendingLegCount: z7.number().int().nonnegative(),
  updatedAt: z7.date()
});
var DeliveryShipmentLegPlanAllocationInputSchema = z7.object({
  partitionId: z7.string().uuid(),
  allocationState: DeliveryShipmentLegAllocationStateSchema.optional(),
  isTerminalDestinationForPartition: z7.boolean().optional(),
  finalRecipientLocationId: z7.string().uuid().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentLegPlanInputSchema = z7.object({
  sequence: z7.number().int().positive(),
  legType: DeliveryShipmentLegTypeSchema,
  originLocationId: z7.string().uuid().nullable().optional(),
  destinationLocationId: z7.string().uuid().nullable().optional(),
  status: DeliveryShipmentLegStatusSchema.optional(),
  assignedDriverId: z7.string().uuid().nullable().optional(),
  onfleetTaskId: z7.string().nullable().optional(),
  onfleetPickupTaskId: z7.string().nullable().optional(),
  onfleetOrderId: z7.string().nullable().optional(),
  onfleetRoutePlanId: z7.string().nullable().optional(),
  startedAt: z7.date().nullable().optional(),
  completedAt: z7.date().nullable().optional(),
  partitionAllocations: z7.array(DeliveryShipmentLegPlanAllocationInputSchema).min(1),
  metadata: z7.record(z7.unknown()).optional()
});
var CreateDeliveryShipmentPlanInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  sourceStockLocationId: z7.string().uuid(),
  status: DeliveryShipmentStatusSchema.optional(),
  metadata: z7.record(z7.unknown()).optional(),
  legs: z7.array(DeliveryShipmentLegPlanInputSchema).min(1)
});
var CreateDeliveryShipmentPlanResultSchema = z7.object({
  shipment: DeliveryShipmentSchema,
  legs: z7.array(DeliveryShipmentLegSchema),
  allocations: z7.array(DeliveryShipmentLegAllocationSchema)
});
var AddHubSplitInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  /** The leg arriving at the hub stop */
  fromLegId: z7.string().uuid(),
  /** Display name for the hub node */
  hubName: z7.string().min(1).optional(),
  /** Stock location ID if the hub is a known warehouse */
  hubStockLocationId: z7.string().uuid().optional(),
  /** Partitions ending their journey at the hub (terminal deliveries) */
  terminalPartitionIds: z7.array(z7.string().uuid()).optional(),
  /** Driver to assign to created downstream legs */
  driverId: z7.string().uuid().optional(),
  /** If true and no driverId, add created legs to the assignment queue */
  queueForAssignment: z7.boolean().optional(),
  notes: z7.string().optional()
});
var AddHubSplitResultSchema = z7.object({
  shipmentId: z7.string().uuid(),
  hubNodeId: z7.string().uuid(),
  fromLegId: z7.string().uuid(),
  terminalCount: z7.number().int().nonnegative(),
  continuingCount: z7.number().int().nonnegative(),
  createdLegs: z7.array(DeliveryShipmentLegSchema),
  /** Driver ID if assigned during creation */
  assignedDriverId: z7.string().uuid().nullable().optional(),
  /** Leg IDs that were added to the assignment queue */
  queuedLegIds: z7.array(z7.string().uuid()).default([])
});
var RemoveHubSplitInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  hubNodeId: z7.string().uuid()
});
var RemoveHubSplitResultSchema = z7.object({
  shipmentId: z7.string().uuid(),
  removedHubNodeId: z7.string().uuid(),
  restoredLegId: z7.string().uuid(),
  deletedLegCount: z7.number().int().nonnegative(),
  restoredPartitionCount: z7.number().int().nonnegative()
});
var InsertWaypointInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  /** The edge to split by inserting a waypoint between its fromNode and toNode */
  fromLegId: z7.string().uuid(),
  /** Display name for the new waypoint/hub node */
  hubName: z7.string().min(1).optional(),
  /** Stock location ID if the waypoint is a known warehouse */
  hubStockLocationId: z7.string().uuid().optional(),
  /** Driver to assign to the new downstream edge */
  driverId: z7.string().uuid().optional(),
  /** If true and no driverId, add the new downstream edge to the assignment queue */
  queueForAssignment: z7.boolean().optional(),
  notes: z7.string().optional()
});
var InsertWaypointResultSchema = z7.object({
  shipmentId: z7.string().uuid(),
  hubNodeId: z7.string().uuid(),
  fromLegId: z7.string().uuid(),
  /** The new downstream edge (hub → original toNode) */
  createdLeg: DeliveryShipmentLegSchema,
  assignedDriverId: z7.string().uuid().nullable(),
  queuedLegId: z7.string().uuid().nullable()
});
var ReorderStopsInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  /** Destination node IDs in the desired order */
  orderedDestinationNodeIds: z7.array(z7.string().uuid()).min(1)
});
var ReorderStopsResultSchema = z7.object({
  shipmentId: z7.string().uuid(),
  reorderedLegCount: z7.number().int().nonnegative(),
  orderedDestinationNodeIds: z7.array(z7.string().uuid())
});
var BatchInsertHubInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  /** Which origin→dest legs to route through this hub */
  legIds: z7.array(z7.string().uuid()).min(1),
  /** Display name for the hub node */
  hubName: z7.string().min(1),
  /** Stock location ID if the hub is a known warehouse */
  hubStockLocationId: z7.string().uuid().optional(),
  /** Explicit driver for the shared origin→hub leg (resolves conflicts) */
  inboundDriverId: z7.string().uuid().optional(),
  /** Layover schedule for overnight hub stays */
  layoverSchedule: z7.object({
    checkInAt: z7.string(),
    checkOutAt: z7.string()
  }).optional()
});
var BatchInsertHubResultSchema = z7.object({
  shipmentId: z7.string().uuid(),
  hubNodeId: z7.string().uuid(),
  /** The shared origin→hub leg */
  inboundLegId: z7.string().uuid(),
  /** New hub→dest legs (one per selected destination) */
  outboundLegIds: z7.array(z7.string().uuid()),
  /** Original origin→dest legs that were replaced */
  removedLegIds: z7.array(z7.string().uuid())
});
var UpdateHubMetadataInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  hubNodeId: z7.string().uuid(),
  layoverSchedule: z7.object({
    checkInAt: z7.string(),
    checkOutAt: z7.string()
  }).nullable()
});
var UpdateHubMetadataResultSchema = z7.object({
  hubNodeId: z7.string().uuid(),
  metadata: z7.record(z7.unknown())
});
var CreateShipmentFromPartitionsInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  partitionIds: z7.array(z7.string().uuid()).min(1),
  queueForAssignment: z7.boolean().optional(),
  notes: z7.string().optional()
});
var CreateShipmentFromPartitionsResultSchema = z7.object({
  shipmentId: z7.string().uuid(),
  legCount: z7.number().int().positive(),
  destinationCount: z7.number().int().nonnegative(),
  untrackedPartitionCount: z7.number().int().nonnegative(),
  queuedLegIds: z7.array(z7.string().uuid())
});
var AssignDestinationLicenseInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  partitionIds: z7.array(z7.string().uuid()).min(1),
  complianceLicenseId: z7.string().uuid()
});
var AssignDestinationLicenseResultSchema = z7.object({
  destinationNodeId: z7.string().uuid(),
  destinationNodeName: z7.string(),
  complianceLicenseId: z7.string().uuid(),
  assignedPartitionCount: z7.number().int().nonnegative(),
  createdAllocations: z7.number().int().nonnegative()
});
var AttachPartitionsToShipmentLegInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  allocations: z7.array(DeliveryShipmentLegPlanAllocationInputSchema).min(1)
});
var DetachPartitionFromShipmentLegInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  partitionId: z7.string().uuid(),
  markRemoved: z7.boolean().default(true)
});
var GetDeliveryShipmentDetailInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid()
});
var DeliveryShipmentTimelineItemSchema = z7.object({
  shipmentId: z7.string().uuid(),
  legId: z7.string().uuid(),
  legSequence: z7.number().int().positive(),
  legType: DeliveryShipmentLegTypeSchema,
  legStatus: DeliveryShipmentLegStatusSchema,
  partitionIds: z7.array(z7.string().uuid()),
  terminalPartitionIds: z7.array(z7.string().uuid()),
  transferredPartitionIds: z7.array(z7.string().uuid()),
  startedAt: z7.date().nullable(),
  completedAt: z7.date().nullable(),
  metadata: z7.record(z7.unknown())
});
var GetDeliveryShipmentDetailResultSchema = z7.object({
  shipment: DeliveryShipmentSchema,
  legs: z7.array(DeliveryShipmentLegSchema),
  allocations: z7.array(DeliveryShipmentLegAllocationSchema),
  timeline: z7.array(DeliveryShipmentTimelineItemSchema),
  /** @deprecated Draft concept removed - always returns empty array */
  downstreamDrafts: z7.array(DeliveryDownstreamTaskDraftSchema).default([])
});
var UpdateShipmentLegInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  /** New destination location (only for linehaul legs) */
  destinationLocationId: z7.string().uuid().nullable().optional(),
  /** Driver to assign (or null to clear) */
  assignedDriverId: z7.string().uuid().nullable().optional(),
  /** Notes to update */
  notes: z7.string().optional()
});
var UpdateShipmentLegResultSchema = z7.object({
  leg: DeliveryShipmentLegSchema
});
var DeleteShipmentInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  force: z7.boolean().default(false)
});
var DeleteShipmentResultSchema = z7.object({
  shipmentId: z7.string().uuid(),
  deletedLegCount: z7.number().int().nonnegative(),
  deletedAllocationCount: z7.number().int().nonnegative(),
  deletedQueueEntryCount: z7.number().int().nonnegative(),
  cancelledOnfleetTaskIds: z7.array(z7.string()),
  warnings: z7.array(z7.string())
});
var DeleteShipmentLegInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  force: z7.boolean().default(false)
});
var DeleteShipmentLegResultSchema = z7.object({
  shipmentLegId: z7.string().uuid(),
  deletedAllocationCount: z7.number().int().nonnegative(),
  deletedQueueEntry: z7.boolean(),
  cancelledOnfleetTaskId: z7.string().nullable(),
  warnings: z7.array(z7.string())
});
var CancelQueueEntryInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid()
});
var CancelQueueEntryResultSchema = z7.object({
  shipmentLegId: z7.string().uuid(),
  queueEntryId: z7.string().uuid().nullable(),
  legStatusReverted: z7.boolean()
});
var ShipmentLegExecutionStrategySchema = z7.enum(["tasks", "orders"]);
var EnsureShipmentLegExecutionInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  strategy: ShipmentLegExecutionStrategySchema.default("tasks"),
  driverId: z7.string().uuid().optional()
});
var EnsureShipmentLegExecutionResultSchema = z7.object({
  shipmentLeg: DeliveryShipmentLegSchema,
  strategy: ShipmentLegExecutionStrategySchema,
  partitionIds: z7.array(z7.string().uuid()),
  onfleetTaskId: z7.string().nullable(),
  onfleetOrderId: z7.string().nullable(),
  groupedPartitionCount: z7.number().int().positive()
});
var DispatchShipmentInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentId: z7.string().uuid(),
  plannedDepartureTime: z7.number().int().positive().optional()
});
var DispatchShipmentPlanSchema = z7.object({
  driverId: z7.string().uuid(),
  driverName: z7.string(),
  routePlanId: z7.string(),
  taskCount: z7.number().int().nonnegative()
});
var DispatchShipmentResultSchema = z7.object({
  shipmentId: z7.string().uuid(),
  shipmentStatus: z7.literal("dispatched"),
  plans: z7.array(DispatchShipmentPlanSchema),
  warnings: z7.array(z7.string()),
  partitionsDispatched: z7.number().int().nonnegative(),
  partitionsSkipped: z7.number().int().nonnegative()
});
var DeliveryShipmentLegManifestStatusSchema = z7.enum([
  "draft",
  "ready",
  "submitted",
  "departed",
  "arrived",
  "voided"
]);
var DeliveryShipmentLegManifestFlowSchema = z7.enum([
  "templates_outgoing",
  "external_incoming"
]);
var DeliveryShipmentLegManifestReadinessIssueSchema = z7.object({
  code: z7.string().min(1),
  message: z7.string().min(1),
  field: z7.string().optional(),
  details: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentLegManifestReadinessSchema = z7.object({
  isReady: z7.boolean(),
  blockingErrors: z7.array(DeliveryShipmentLegManifestReadinessIssueSchema),
  warnings: z7.array(DeliveryShipmentLegManifestReadinessIssueSchema),
  info: z7.array(DeliveryShipmentLegManifestReadinessIssueSchema).default([]),
  checkedAt: z7.date(),
  metadata: z7.record(z7.unknown()).default({})
});
var DeliveryShipmentLegManifestShipperSchema = z7.object({
  facilityLicenseNumber: z7.string().min(1).nullable().optional(),
  facilityName: z7.string().nullable().optional()
});
var DeliveryShipmentLegManifestDestinationSchema = z7.object({
  recipientFacilityLicenseNumber: z7.string().min(1).nullable().optional(),
  recipientFacilityName: z7.string().nullable().optional(),
  plannedRoute: z7.string().nullable().optional(),
  estimatedDepartureAt: z7.date().nullable().optional(),
  estimatedArrivalAt: z7.date().nullable().optional(),
  actualDepartureAt: z7.date().nullable().optional(),
  actualArrivalAt: z7.date().nullable().optional()
});
var DeliveryShipmentLegManifestTransporterSchema = z7.object({
  transporterFacilityLicenseNumber: z7.string().nullable().optional(),
  transporterFacilityName: z7.string().nullable().optional(),
  driverName: z7.string().nullable().optional(),
  driverOccupationalLicenseNumber: z7.string().nullable().optional(),
  driverVehicleLicenseNumber: z7.string().nullable().optional(),
  vehicleMake: z7.string().nullable().optional(),
  vehicleModel: z7.string().nullable().optional(),
  vehicleLicensePlateNumber: z7.string().nullable().optional()
});
var DeliveryShipmentLegManifestPackageSchema = z7.object({
  packageLabel: z7.string().min(1),
  quantity: z7.number().nonnegative(),
  unitOfMeasureName: z7.string().nullable().optional(),
  grossWeight: z7.number().nullable().optional(),
  grossUnitOfWeightName: z7.string().nullable().optional(),
  productName: z7.string().nullable().optional(),
  metadata: z7.record(z7.unknown()).default({})
});
var DeliveryShipmentLegManifestPayloadSnapshotSchema = z7.object({
  flow: DeliveryShipmentLegManifestFlowSchema.default("templates_outgoing"),
  transferTypeName: z7.string().nullable().optional(),
  name: z7.string().nullable().optional(),
  plannedRoute: z7.string().nullable().optional(),
  shipper: DeliveryShipmentLegManifestShipperSchema,
  destinations: z7.array(DeliveryShipmentLegManifestDestinationSchema).default([]),
  transporters: z7.array(DeliveryShipmentLegManifestTransporterSchema).default([]),
  packages: z7.array(DeliveryShipmentLegManifestPackageSchema).default([]),
  metadata: z7.record(z7.unknown()).default({})
});
var DeliveryShipmentLegManifestSchema = z7.object({
  id: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  organizationId: z7.string().uuid(),
  status: DeliveryShipmentLegManifestStatusSchema,
  version: z7.number().int().positive(),
  metrcFlow: DeliveryShipmentLegManifestFlowSchema,
  metrcTransferId: z7.number().int().positive().nullable(),
  metrcManifestNumber: z7.string().nullable(),
  payloadSnapshot: DeliveryShipmentLegManifestPayloadSnapshotSchema,
  readinessSnapshot: DeliveryShipmentLegManifestReadinessSchema.nullable(),
  lastPreparedAt: z7.date().nullable(),
  submittedAt: z7.date().nullable(),
  departedAt: z7.date().nullable(),
  arrivedAt: z7.date().nullable(),
  voidedAt: z7.date().nullable(),
  metadata: z7.record(z7.unknown()),
  createdAt: z7.date(),
  updatedAt: z7.date()
});
var CreateDeliveryShipmentLegManifestSchema = z7.object({
  shipmentLegId: z7.string().uuid(),
  organizationId: z7.string().uuid(),
  status: DeliveryShipmentLegManifestStatusSchema.default("draft"),
  version: z7.number().int().positive().default(1),
  metrcFlow: DeliveryShipmentLegManifestFlowSchema.default("templates_outgoing"),
  metrcTransferId: z7.number().int().positive().nullable().optional(),
  metrcManifestNumber: z7.string().nullable().optional(),
  payloadSnapshot: DeliveryShipmentLegManifestPayloadSnapshotSchema,
  readinessSnapshot: DeliveryShipmentLegManifestReadinessSchema.nullable().optional(),
  lastPreparedAt: z7.date().nullable().optional(),
  submittedAt: z7.date().nullable().optional(),
  departedAt: z7.date().nullable().optional(),
  arrivedAt: z7.date().nullable().optional(),
  voidedAt: z7.date().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var UpdateDeliveryShipmentLegManifestSchema = z7.object({
  status: DeliveryShipmentLegManifestStatusSchema.optional(),
  version: z7.number().int().positive().optional(),
  metrcFlow: DeliveryShipmentLegManifestFlowSchema.optional(),
  metrcTransferId: z7.number().int().positive().nullable().optional(),
  metrcManifestNumber: z7.string().nullable().optional(),
  payloadSnapshot: DeliveryShipmentLegManifestPayloadSnapshotSchema.optional(),
  readinessSnapshot: DeliveryShipmentLegManifestReadinessSchema.nullable().optional(),
  lastPreparedAt: z7.date().nullable().optional(),
  submittedAt: z7.date().nullable().optional(),
  departedAt: z7.date().nullable().optional(),
  arrivedAt: z7.date().nullable().optional(),
  voidedAt: z7.date().nullable().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentLegManifestFiltersSchema = z7.object({
  shipmentLegId: z7.string().uuid().optional(),
  status: DeliveryShipmentLegManifestStatusSchema.optional(),
  statuses: z7.array(DeliveryShipmentLegManifestStatusSchema).optional(),
  metrcTransferId: z7.number().int().positive().optional(),
  limit: z7.number().int().positive().optional()
});
var GetShipmentLegManifestInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid()
});
var PrepareShipmentLegManifestInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  shipmentLegId: z7.string().uuid(),
  manifestName: z7.string().min(1).optional(),
  plannedRoute: z7.string().min(1).optional(),
  transferTypeName: z7.string().min(1).optional(),
  force: z7.boolean().default(false),
  metadata: z7.record(z7.unknown()).optional()
});
var PrepareShipmentLegManifestResultSchema = z7.object({
  manifest: DeliveryShipmentLegManifestSchema,
  readiness: DeliveryShipmentLegManifestReadinessSchema
});
var SubmitShipmentLegManifestInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  memberId: z7.string().uuid().optional(),
  shipmentLegId: z7.string().uuid(),
  expectedVersion: z7.number().int().positive().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var UpdateShipmentLegManifestInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  memberId: z7.string().uuid().optional(),
  shipmentLegId: z7.string().uuid(),
  expectedVersion: z7.number().int().positive().optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var VoidShipmentLegManifestInputSchema = z7.object({
  organizationId: z7.string().uuid(),
  memberId: z7.string().uuid().optional(),
  shipmentLegId: z7.string().uuid(),
  expectedVersion: z7.number().int().positive().optional(),
  reason: z7.string().min(1).optional(),
  metadata: z7.record(z7.unknown()).optional()
});
var DeliveryShipmentDtoSchema = DeliveryShipmentSchema.extend({
  createdAt: z7.string().datetime(),
  updatedAt: z7.string().datetime()
});
var DeliveryShipmentLegDtoSchema = DeliveryShipmentLegSchema.extend({
  startedAt: z7.string().datetime().nullable(),
  completedAt: z7.string().datetime().nullable(),
  createdAt: z7.string().datetime(),
  updatedAt: z7.string().datetime()
});
var DeliveryShipmentLegAllocationDtoSchema = DeliveryShipmentLegAllocationSchema.extend({
  createdAt: z7.string().datetime(),
  updatedAt: z7.string().datetime()
});
var DeliveryShipmentLegManifestReadinessDtoSchema = DeliveryShipmentLegManifestReadinessSchema.extend({
  checkedAt: z7.string().datetime()
});
var DeliveryShipmentLegManifestDestinationDtoSchema = DeliveryShipmentLegManifestDestinationSchema.extend({
  estimatedDepartureAt: z7.string().datetime().nullable().optional(),
  estimatedArrivalAt: z7.string().datetime().nullable().optional(),
  actualDepartureAt: z7.string().datetime().nullable().optional(),
  actualArrivalAt: z7.string().datetime().nullable().optional()
});
var DeliveryShipmentLegManifestPayloadSnapshotDtoSchema = DeliveryShipmentLegManifestPayloadSnapshotSchema.extend({
  destinations: z7.array(DeliveryShipmentLegManifestDestinationDtoSchema).default([])
});
var DeliveryShipmentLegManifestDtoSchema = DeliveryShipmentLegManifestSchema.extend({
  payloadSnapshot: DeliveryShipmentLegManifestPayloadSnapshotDtoSchema,
  readinessSnapshot: DeliveryShipmentLegManifestReadinessDtoSchema.nullable(),
  lastPreparedAt: z7.string().datetime().nullable(),
  submittedAt: z7.string().datetime().nullable(),
  departedAt: z7.string().datetime().nullable(),
  arrivedAt: z7.string().datetime().nullable(),
  voidedAt: z7.string().datetime().nullable(),
  createdAt: z7.string().datetime(),
  updatedAt: z7.string().datetime()
});
var DeliveryShipmentLegMetrcRefDtoSchema = DeliveryShipmentLegMetrcRefSchema.extend({
  metrcTransporterAcceptedAt: z7.string().datetime().nullable(),
  metrcEstimatedDepartureAt: z7.string().datetime().nullable(),
  metrcActualDepartureAt: z7.string().datetime().nullable(),
  metrcEstimatedArrivalAt: z7.string().datetime().nullable(),
  metrcActualArrivalAt: z7.string().datetime().nullable(),
  createdAt: z7.string().datetime(),
  updatedAt: z7.string().datetime()
});
var DeliveryShipmentLegQueueEntryDtoSchema = DeliveryShipmentLegQueueEntrySchema.extend({
  expiresAt: z7.string().datetime().nullable(),
  enqueuedAt: z7.string().datetime(),
  assignedAt: z7.string().datetime().nullable(),
  createdAt: z7.string().datetime(),
  updatedAt: z7.string().datetime()
});
var DeliveryShipmentLegQueueListItemDtoSchema = DeliveryShipmentLegQueueEntryDtoSchema.extend({
  shipmentId: z7.string().uuid(),
  legType: DeliveryShipmentLegTypeSchema,
  legStatus: DeliveryShipmentLegStatusSchema,
  originLocationId: z7.string().uuid().nullable(),
  originLocationName: z7.string().nullable(),
  destinationLocationId: z7.string().uuid().nullable(),
  destinationLocationName: z7.string().nullable(),
  partitionCount: z7.number().int().nonnegative(),
  partitionIds: z7.array(z7.string().uuid()),
  metrcManifestCount: z7.number().int().nonnegative()
});
var DeliveryShipmentLegQueueSummaryDtoSchema = DeliveryShipmentLegQueueSummarySchema.extend({
  updatedAt: z7.string().datetime()
});
var DeliveryDownstreamTaskDraftDtoSchema = DeliveryDownstreamTaskDraftSchema.extend({
  createdAt: z7.string().datetime(),
  updatedAt: z7.string().datetime()
});
var DeliveryShipmentTimelineItemDtoSchema = DeliveryShipmentTimelineItemSchema.extend({
  startedAt: z7.string().datetime().nullable(),
  completedAt: z7.string().datetime().nullable()
});

// delivery/shipment-auxiliary-task.schema.ts
import { z as z8 } from "zod";
var ShipmentAuxiliaryTaskCategorySchema = z8.enum(["hub_waypoint", "operational"]);
var ShipmentAuxiliaryTaskTypeSchema = z8.enum([
  "pickup",
  "dropoff",
  "handoff",
  "inspection",
  "other"
]);
var ShipmentAuxiliaryTaskStatusSchema = z8.enum(["pending", "completed", "cancelled"]);
var AuxiliaryTaskAddressSchema = z8.object({
  address1: z8.string(),
  address2: z8.string().nullable().optional(),
  city: z8.string(),
  province: z8.string(),
  postalCode: z8.string()
});
var ShipmentAuxiliaryTaskSchema = z8.object({
  id: z8.string().uuid(),
  shipmentId: z8.string().uuid(),
  shipmentLegId: z8.string().uuid().nullable(),
  taskCategory: ShipmentAuxiliaryTaskCategorySchema,
  taskType: ShipmentAuxiliaryTaskTypeSchema,
  onfleetTaskId: z8.string().nullable(),
  planNodeId: z8.string().uuid().nullable(),
  description: z8.string().nullable(),
  address: AuxiliaryTaskAddressSchema.nullable(),
  recipientName: z8.string().nullable(),
  recipientPhone: z8.string().nullable(),
  sortOrder: z8.number().int(),
  status: ShipmentAuxiliaryTaskStatusSchema,
  metadata: z8.record(z8.unknown()),
  createdAt: z8.date(),
  updatedAt: z8.date()
});
var CreateShipmentAuxiliaryTaskSchema = z8.object({
  shipmentId: z8.string().uuid(),
  shipmentLegId: z8.string().uuid().nullable().optional(),
  taskCategory: ShipmentAuxiliaryTaskCategorySchema,
  taskType: ShipmentAuxiliaryTaskTypeSchema,
  onfleetTaskId: z8.string().nullable().optional(),
  planNodeId: z8.string().uuid().nullable().optional(),
  description: z8.string().nullable().optional(),
  address: AuxiliaryTaskAddressSchema.nullable().optional(),
  recipientName: z8.string().nullable().optional(),
  recipientPhone: z8.string().nullable().optional(),
  sortOrder: z8.number().int().optional(),
  status: ShipmentAuxiliaryTaskStatusSchema.optional(),
  metadata: z8.record(z8.unknown()).optional()
});
var UpdateShipmentAuxiliaryTaskSchema = z8.object({
  shipmentLegId: z8.string().uuid().nullable().optional(),
  onfleetTaskId: z8.string().nullable().optional(),
  description: z8.string().nullable().optional(),
  address: AuxiliaryTaskAddressSchema.nullable().optional(),
  recipientName: z8.string().nullable().optional(),
  recipientPhone: z8.string().nullable().optional(),
  sortOrder: z8.number().int().optional(),
  status: ShipmentAuxiliaryTaskStatusSchema.optional(),
  metadata: z8.record(z8.unknown()).optional()
});

// delivery/shipment-leg-metrc-ops.schema.ts
import { z as z9 } from "zod";
var ShipmentLegMetrcRefSourceSchema = z9.enum([
  "partition_metadata",
  "shipment_leg_metadata",
  "backfill",
  "manual"
]);
var ShipmentLegMetrcLinkInputSchema = z9.object({
  organizationId: z9.string().uuid(),
  shipmentLegId: z9.string().uuid(),
  partitionId: z9.string().uuid().nullable().optional(),
  partitionMetadata: z9.record(z9.unknown()).optional(),
  legMetadata: z9.record(z9.unknown()).optional(),
  source: ShipmentLegMetrcRefSourceSchema.default("manual"),
  ensureRow: z9.boolean().default(true),
  metadata: z9.record(z9.unknown()).optional()
});
var ShipmentLegMetrcBackfillInputSchema = z9.object({
  organizationId: z9.string().uuid(),
  fromDate: z9.date().optional(),
  toDate: z9.date().optional(),
  partitionIds: z9.array(z9.string().uuid()).default([]),
  limit: z9.number().int().positive().default(1e3),
  apply: z9.boolean().default(false)
});
var ShipmentLegMetrcBackfillPartitionQuerySchema = z9.object({
  organizationId: z9.string().uuid(),
  fromDate: z9.date().optional(),
  toDate: z9.date().optional(),
  limit: z9.number().int().positive().default(1e3)
});
var ShipmentLegMetrcBackfillRecordCategorySchema = z9.enum([
  "mapped",
  "ambiguous",
  "unmapped",
  "failed"
]);
var ShipmentLegMetrcBackfillRecordSchema = z9.object({
  category: ShipmentLegMetrcBackfillRecordCategorySchema,
  partitionId: z9.string().uuid(),
  shipmentLegId: z9.string().uuid().nullable(),
  reason: z9.string(),
  metrcManifestNumber: z9.string().nullable().optional(),
  details: z9.record(z9.unknown()).optional()
});
var ShipmentLegMetrcBackfillMetricsSchema = z9.object({
  scannedPartitions: z9.number().int().nonnegative(),
  mapped: z9.number().int().nonnegative(),
  ambiguous: z9.number().int().nonnegative(),
  unmapped: z9.number().int().nonnegative(),
  failed: z9.number().int().nonnegative()
});
var ShipmentLegMetrcBackfillReportSchema = z9.object({
  dryRun: z9.boolean(),
  scope: ShipmentLegMetrcBackfillInputSchema,
  metrics: ShipmentLegMetrcBackfillMetricsSchema,
  records: z9.array(ShipmentLegMetrcBackfillRecordSchema)
});
var ShipmentLegMetrcReconciliationInputSchema = z9.object({
  organizationId: z9.string().uuid(),
  fromDate: z9.date().optional(),
  toDate: z9.date().optional(),
  limit: z9.number().int().positive().default(1e3)
});
var ShipmentLegMetrcReconciliationIssueTypeSchema = z9.enum([
  "missing_leg_level_ref",
  "missing_partition_ref",
  "missing_manifest_number",
  "missing_delivery_id",
  "missing_transfer_id",
  "manifest_reused_within_leg"
]);
var ShipmentLegMetrcReconciliationIssueSchema = z9.object({
  issueType: ShipmentLegMetrcReconciliationIssueTypeSchema,
  organizationId: z9.string().uuid(),
  shipmentId: z9.string().uuid(),
  shipmentLegId: z9.string().uuid(),
  partitionId: z9.string().uuid().nullable().optional(),
  metrcManifestNumber: z9.string().nullable().optional(),
  message: z9.string(),
  expected: z9.string().nullable().optional(),
  actual: z9.string().nullable().optional()
});
var ShipmentLegMetrcReconciliationMetricsSchema = z9.object({
  legsChecked: z9.number().int().nonnegative(),
  allocationsChecked: z9.number().int().nonnegative(),
  refsChecked: z9.number().int().nonnegative(),
  missingLegLevelRefs: z9.number().int().nonnegative(),
  missingPartitionRefs: z9.number().int().nonnegative(),
  missingManifestNumbers: z9.number().int().nonnegative(),
  missingDeliveryIds: z9.number().int().nonnegative(),
  missingTransferIds: z9.number().int().nonnegative(),
  manifestReuseConflicts: z9.number().int().nonnegative(),
  issuesFound: z9.number().int().nonnegative()
});
var ShipmentLegMetrcReconciliationReportSchema = z9.object({
  scope: ShipmentLegMetrcReconciliationInputSchema,
  metrics: ShipmentLegMetrcReconciliationMetricsSchema,
  issues: z9.array(ShipmentLegMetrcReconciliationIssueSchema)
});
var ShipmentLegMetrcRefFieldSubsetSchema = UpdateDeliveryShipmentLegMetrcRefSchema.pick({
  metrcDeliveryId: true,
  metrcTransferId: true,
  metrcManifestNumber: true,
  isLayover: true,
  metrcTransporterFacilityLicenseNumber: true,
  metrcTransporterAcceptedAt: true,
  metrcEstimatedDepartureAt: true,
  metrcActualDepartureAt: true,
  metrcEstimatedArrivalAt: true,
  metrcActualArrivalAt: true
});

// delivery/proof-asset.schema.ts
import { z as z10 } from "zod";
var DeliveryProofAssetTypeSchema = z10.enum(["photo", "signature"]);
var DeliveryProofAssetStatusSchema = z10.enum(["pending", "synced", "failed"]);
var DbDeliveryPartitionProofAssetSchema = z10.object({
  id: z10.string().uuid(),
  partition_id: z10.string().uuid(),
  task_id: z10.string().uuid(),
  onfleet_task_short_id: z10.string().nullable(),
  asset_type: DeliveryProofAssetTypeSchema,
  onfleet_upload_id: z10.string(),
  source_url: z10.string().nullable(),
  r2_bucket: z10.string().nullable(),
  r2_key: z10.string().nullable(),
  public_url: z10.string().nullable(),
  captured_at: z10.union([z10.string(), z10.date()]).nullable(),
  synced_at: z10.union([z10.string(), z10.date()]).nullable(),
  status: DeliveryProofAssetStatusSchema,
  error: z10.string().nullable(),
  created_at: z10.union([z10.string(), z10.date()]),
  updated_at: z10.union([z10.string(), z10.date()])
});
var DeliveryPartitionProofAssetSchema = z10.object({
  id: z10.string().uuid(),
  partitionId: z10.string().uuid(),
  taskId: z10.string().uuid(),
  onfleetTaskShortId: z10.string().nullable(),
  assetType: DeliveryProofAssetTypeSchema,
  onfleetUploadId: z10.string(),
  sourceUrl: z10.string().nullable(),
  r2Bucket: z10.string().nullable(),
  r2Key: z10.string().nullable(),
  publicUrl: z10.string().nullable(),
  capturedAt: z10.date().nullable(),
  syncedAt: z10.date().nullable(),
  status: DeliveryProofAssetStatusSchema,
  error: z10.string().nullable(),
  createdAt: z10.date(),
  updatedAt: z10.date()
});
var UpsertPendingDeliveryProofAssetInputSchema = z10.object({
  partitionId: z10.string().uuid(),
  taskId: z10.string().uuid(),
  onfleetTaskShortId: z10.string().nullable().optional(),
  assetType: DeliveryProofAssetTypeSchema,
  onfleetUploadId: z10.string().min(1),
  sourceUrl: z10.string().nullable().optional(),
  capturedAt: z10.date().nullable().optional()
});
var MarkDeliveryProofAssetSyncedInputSchema = z10.object({
  sourceUrl: z10.string().nullable().optional(),
  r2Bucket: z10.string(),
  r2Key: z10.string(),
  publicUrl: z10.string(),
  syncedAt: z10.date().optional()
});
var DeliveryPartitionProofSummarySchema = z10.object({
  partitionId: z10.string().uuid(),
  hasSignature: z10.boolean(),
  photoCount: z10.number().int().nonnegative()
});

// delivery/delivery-destination.schema.ts
import { z as z11 } from "zod";
var DeliveryDestinationSchema = z11.object({
  id: z11.string(),
  source: z11.enum(["organization_location", "customer_address"]),
  name: z11.string(),
  address: z11.object({
    address1: z11.string(),
    address2: z11.string().nullable().optional(),
    city: z11.string(),
    province: z11.string(),
    postalCode: z11.string(),
    countryCode: z11.string().optional()
  }),
  complianceLicenseId: z11.string().uuid().nullable().optional(),
  complianceLicenseNumber: z11.string().nullable().optional(),
  organizationLocationId: z11.string().uuid().nullable().optional()
});
var DeliveryDestinationsResponseSchema = z11.object({
  destinations: z11.array(DeliveryDestinationSchema),
  canCreateDestination: z11.boolean()
});
var CreateDeliveryDestinationSchema = z11.object({
  name: z11.string().min(1, "Location name is required"),
  address1: z11.string().min(1, "Street address is required"),
  address2: z11.string().nullable().optional(),
  city: z11.string().min(1, "City is required"),
  province: z11.string().min(1, "State is required"),
  postalCode: z11.string().min(1, "ZIP code is required"),
  locationType: LocationTypeSchema.optional()
});

// delivery/logistics.schema.ts
import { z as z12 } from "zod";
var DerivedShipmentTaskSchema = z12.object({
  onfleetTaskId: z12.string(),
  destinationNodeId: z12.string().uuid().nullable(),
  legId: z12.string().uuid(),
  legSequence: z12.number().int(),
  assignedDriverId: z12.string().uuid().nullable(),
  taskCategory: z12.enum(["partition_delivery", "leg_delivery", "hub_waypoint", "operational"]),
  sortOrder: z12.number().int(),
  /** For partition deliveries — which partition this task belongs to */
  partitionId: z12.string().uuid().nullable(),
  /** For auxiliary tasks — the shipment_auxiliary_tasks row ID */
  auxiliaryTaskId: z12.string().uuid().nullable()
});
var PartitionDiagnosticsSchema = z12.object({
  partitionId: z12.string().uuid(),
  onfleetTaskId: z12.string().nullable(),
  taskExistsInOnfleet: z12.boolean(),
  onfleetTaskState: z12.number().int().nullable(),
  assignedWorker: z12.string().nullable(),
  inRoutePlan: z12.boolean(),
  routePlanId: z12.string().nullable()
});
var ShipmentDiagnosticsSchema = z12.object({
  shipmentId: z12.string().uuid(),
  legCount: z12.number().int(),
  routePlanCount: z12.number().int(),
  partitionTasksExpected: z12.number().int(),
  partitionTasksFound: z12.number().int(),
  auxiliaryTasksCount: z12.number().int(),
  missingOnfleetTasks: z12.array(z12.string().uuid()),
  orphanedRoutePlans: z12.array(z12.string()),
  driverMismatches: z12.array(
    z12.object({
      legId: z12.string().uuid(),
      floteDriver: z12.string(),
      onfleetWorker: z12.string()
    })
  )
});

// delivery/carrier-tracking.types.ts
import { z as z13 } from "zod";
var CarrierTrackingStatusSchema = z13.enum([
  "unknown",
  "pre_transit",
  "in_transit",
  "out_for_delivery",
  "delivered",
  "available_for_pickup",
  "return_to_sender",
  "failure",
  "cancelled"
]);
var CarrierTrackingLocationSchema = z13.object({
  city: z13.string().nullable(),
  state: z13.string().nullable(),
  zip: z13.string().nullable(),
  country: z13.string().nullable()
});
var CarrierTrackingEventSchema = z13.object({
  timestamp: z13.string(),
  status: CarrierTrackingStatusSchema,
  description: z13.string(),
  location: CarrierTrackingLocationSchema.nullable()
});
var CarrierTrackingSnapshotSchema = z13.object({
  partitionId: z13.string(),
  trackingNumber: z13.string(),
  carrier: z13.string(),
  status: CarrierTrackingStatusSchema,
  statusDescription: z13.string(),
  estimatedDeliveryDate: z13.string().nullable(),
  publicTrackingUrl: z13.string().nullable(),
  signedBy: z13.string().nullable(),
  events: z13.array(CarrierTrackingEventSchema),
  lastUpdatedAt: z13.string()
});
export {
  AddHubSplitInputSchema,
  AddHubSplitResultSchema,
  AssignDestinationLicenseInputSchema,
  AssignDestinationLicenseResultSchema,
  AssignmentQueueEntryDtoSchema,
  AssignmentQueueEntrySchema,
  AssignmentQueueFiltersSchema,
  AssignmentQueueStatsSchema,
  AssignmentQueueStatusSchema,
  AttachPartitionsToShipmentLegInputSchema,
  AuxiliaryTaskAddressSchema,
  BatchInsertHubInputSchema,
  BatchInsertHubResultSchema,
  BrandFulfillmentSummarySchema,
  CancelQueueEntryInputSchema,
  CancelQueueEntryResultSchema,
  CarrierTrackingEventSchema,
  CarrierTrackingLocationSchema,
  CarrierTrackingSnapshotSchema,
  CarrierTrackingStatusSchema,
  CreateAssignmentQueueEntrySchema,
  CreateDeliveryDestinationSchema,
  CreateDeliveryShipmentLegAllocationSchema,
  CreateDeliveryShipmentLegManifestSchema,
  CreateDeliveryShipmentLegMetrcRefSchema,
  CreateDeliveryShipmentLegQueueEntrySchema,
  CreateDeliveryShipmentLegSchema,
  CreateDeliveryShipmentManifestSchema,
  CreateDeliveryShipmentPartitionAllocationSchema,
  CreateDeliveryShipmentPlanInputSchema,
  CreateDeliveryShipmentPlanNodeSchema,
  CreateDeliveryShipmentPlanResultSchema,
  CreateDeliveryShipmentSchema,
  CreateFulfillmentOfferDtoSchema,
  CreateFulfillmentRecordDtoSchema,
  CreateOrderPartitionDtoSchema,
  CreateOrderPartitionItemBatchReservationDtoSchema,
  CreateOrderPartitionItemDtoSchema,
  CreateShipmentAuxiliaryTaskSchema,
  CreateShipmentFromPartitionsInputSchema,
  CreateShipmentFromPartitionsResultSchema,
  DbAssignmentQueueSchema,
  DbDeliveryPartitionProofAssetSchema,
  DbFulfillmentOfferSchema,
  DbFulfillmentRecordSchema,
  DbOrderPartitionItemBatchReservationSchema,
  DbOrderPartitionItemSchema,
  DbOrderPartitionSchema,
  DeleteShipmentInputSchema,
  DeleteShipmentLegInputSchema,
  DeleteShipmentLegResultSchema,
  DeleteShipmentResultSchema,
  DeliveryDestinationSchema,
  DeliveryDestinationsResponseSchema,
  DeliveryDownstreamTaskDraftDtoSchema,
  DeliveryDownstreamTaskDraftSchema,
  DeliveryPartitionProofAssetSchema,
  DeliveryPartitionProofSummarySchema,
  DeliveryProofAssetStatusSchema,
  DeliveryProofAssetTypeSchema,
  DeliveryShipmentDtoSchema,
  DeliveryShipmentFiltersSchema,
  DeliveryShipmentLegAllocationDtoSchema,
  DeliveryShipmentLegAllocationFiltersSchema,
  DeliveryShipmentLegAllocationSchema,
  DeliveryShipmentLegAllocationStateSchema,
  DeliveryShipmentLegDtoSchema,
  DeliveryShipmentLegFiltersSchema,
  DeliveryShipmentLegManifestDestinationDtoSchema,
  DeliveryShipmentLegManifestDestinationSchema,
  DeliveryShipmentLegManifestDtoSchema,
  DeliveryShipmentLegManifestFiltersSchema,
  DeliveryShipmentLegManifestFlowSchema,
  DeliveryShipmentLegManifestPackageSchema,
  DeliveryShipmentLegManifestPayloadSnapshotDtoSchema,
  DeliveryShipmentLegManifestPayloadSnapshotSchema,
  DeliveryShipmentLegManifestReadinessDtoSchema,
  DeliveryShipmentLegManifestReadinessIssueSchema,
  DeliveryShipmentLegManifestReadinessSchema,
  DeliveryShipmentLegManifestSchema,
  DeliveryShipmentLegManifestShipperSchema,
  DeliveryShipmentLegManifestStatusSchema,
  DeliveryShipmentLegManifestTransporterSchema,
  DeliveryShipmentLegMetrcRefDtoSchema,
  DeliveryShipmentLegMetrcRefFiltersSchema,
  DeliveryShipmentLegMetrcRefSchema,
  DeliveryShipmentLegPlanAllocationInputSchema,
  DeliveryShipmentLegPlanInputSchema,
  DeliveryShipmentLegQueueEntryDtoSchema,
  DeliveryShipmentLegQueueEntrySchema,
  DeliveryShipmentLegQueueFiltersSchema,
  DeliveryShipmentLegQueueListItemDtoSchema,
  DeliveryShipmentLegQueueListItemSchema,
  DeliveryShipmentLegQueueStatsSchema,
  DeliveryShipmentLegQueueStatusSchema,
  DeliveryShipmentLegQueueSummaryDtoSchema,
  DeliveryShipmentLegQueueSummarySchema,
  DeliveryShipmentLegSchema,
  DeliveryShipmentLegStatusSchema,
  DeliveryShipmentLegTypeSchema,
  DeliveryShipmentManifestDtoSchema,
  DeliveryShipmentManifestFlowSchema,
  DeliveryShipmentManifestReadinessDtoSchema,
  DeliveryShipmentManifestReadinessIssueSchema,
  DeliveryShipmentManifestReadinessSchema,
  DeliveryShipmentManifestSchema,
  DeliveryShipmentManifestStatusSchema,
  DeliveryShipmentPartitionAllocationDtoSchema,
  DeliveryShipmentPartitionAllocationSchema,
  DeliveryShipmentPartitionAllocationStateSchema,
  DeliveryShipmentPlanNodeDtoSchema,
  DeliveryShipmentPlanNodeSchema,
  DeliveryShipmentPlanNodeTypeSchema,
  DeliveryShipmentSchema,
  DeliveryShipmentStatusSchema,
  DeliveryShipmentTimelineItemDtoSchema,
  DeliveryShipmentTimelineItemSchema,
  DerivedShipmentTaskSchema,
  DetachPartitionFromShipmentLegInputSchema,
  DispatchShipmentInputSchema,
  DispatchShipmentPlanSchema,
  DispatchShipmentResultSchema,
  DownstreamDraftPublishStatusSchema,
  EnsureShipmentLegExecutionInputSchema,
  EnsureShipmentLegExecutionResultSchema,
  ExpireOffersResponseDtoSchema,
  FulfillmentOfferDtoSchema,
  FulfillmentOfferFiltersSchema,
  FulfillmentOfferSchema,
  FulfillmentOfferStatusSchema,
  FulfillmentOfferWithPartitionAndItemsDtoSchema,
  FulfillmentOfferWithPartitionDtoSchema,
  FulfillmentRecordDtoSchema,
  FulfillmentRecordFiltersSchema,
  FulfillmentRecordFulfillmentTypeSchema,
  FulfillmentRecordSchema,
  FulfillmentResultSchema,
  GetDeliveryShipmentDetailInputSchema,
  GetDeliveryShipmentDetailResultSchema,
  GetShipmentLegManifestInputSchema,
  HubLayoverScheduleSchema,
  HubNodeMetadataSchema,
  InsertWaypointInputSchema,
  InsertWaypointResultSchema,
  MarkDeliveryProofAssetSyncedInputSchema,
  NodeAddressSnapshotSchema,
  OfferResponseDtoSchema,
  OnfleetWebhookTriggers,
  OrderPartitionDtoSchema,
  OrderPartitionFiltersSchema,
  OrderPartitionFulfillmentStatusSchema,
  OrderPartitionFulfillmentTypeSchema,
  OrderPartitionItemBatchReservationSchema,
  OrderPartitionItemSchema,
  OrderPartitionItemWithProductSchema,
  OrderPartitionPreparationStatusSchema,
  OrderPartitionSchema,
  PaginatedFulfillmentOffersSchema,
  PaginatedOrderPartitionsSchema,
  PartitionDiagnosticsSchema,
  PartitionItemDtoSchema,
  PrepareShipmentLegManifestInputSchema,
  PrepareShipmentLegManifestResultSchema,
  RemoveHubSplitInputSchema,
  RemoveHubSplitResultSchema,
  ReorderStopsInputSchema,
  ReorderStopsResultSchema,
  RespondToOfferDtoSchema,
  ShipmentAuxiliaryTaskCategorySchema,
  ShipmentAuxiliaryTaskSchema,
  ShipmentAuxiliaryTaskStatusSchema,
  ShipmentAuxiliaryTaskTypeSchema,
  ShipmentDiagnosticsSchema,
  ShipmentLegExecutionStrategySchema,
  ShipmentLegMetrcBackfillInputSchema,
  ShipmentLegMetrcBackfillMetricsSchema,
  ShipmentLegMetrcBackfillPartitionQuerySchema,
  ShipmentLegMetrcBackfillRecordCategorySchema,
  ShipmentLegMetrcBackfillRecordSchema,
  ShipmentLegMetrcBackfillReportSchema,
  ShipmentLegMetrcLinkInputSchema,
  ShipmentLegMetrcReconciliationInputSchema,
  ShipmentLegMetrcReconciliationIssueSchema,
  ShipmentLegMetrcReconciliationIssueTypeSchema,
  ShipmentLegMetrcReconciliationMetricsSchema,
  ShipmentLegMetrcReconciliationReportSchema,
  ShipmentLegMetrcRefFieldSubsetSchema,
  ShipmentLegMetrcRefSourceSchema,
  ShipmentManifestDestinationSchema,
  ShipmentManifestPackageSchema,
  ShipmentManifestPayloadSnapshotSchema,
  ShipmentManifestShipperSchema,
  ShipmentManifestTransporterDetailSchema,
  ShipmentManifestTransporterSchema,
  StalePartitionFiltersSchema,
  StockLocationPerformanceSchema,
  SubmitShipmentLegManifestInputSchema,
  UpdateAssignmentQueueEntrySchema,
  UpdateDeliveryShipmentLegAllocationSchema,
  UpdateDeliveryShipmentLegManifestSchema,
  UpdateDeliveryShipmentLegMetrcRefSchema,
  UpdateDeliveryShipmentLegQueueEntrySchema,
  UpdateDeliveryShipmentLegSchema,
  UpdateDeliveryShipmentManifestSchema,
  UpdateDeliveryShipmentPartitionAllocationSchema,
  UpdateDeliveryShipmentPlanNodeSchema,
  UpdateDeliveryShipmentSchema,
  UpdateHubMetadataInputSchema,
  UpdateHubMetadataResultSchema,
  UpdateOrderPartitionDtoSchema,
  UpdateShipmentAuxiliaryTaskSchema,
  UpdateShipmentLegInputSchema,
  UpdateShipmentLegManifestInputSchema,
  UpdateShipmentLegResultSchema,
  UpsertPendingDeliveryProofAssetInputSchema,
  VoidShipmentLegManifestInputSchema
};
